var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0432 15.5C12.7336 15.5 13.2932 16.0596 13.2932 16.75C13.2932 17.4403 12.7336 18 12.0432 18C11.3531 17.9998 10.7933 17.4402 10.7932 16.75C10.7932 16.0598 11.3531 15.5002 12.0432 15.5Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0432 5C12.5955 5 13.0432 5.44772 13.0432 6V13C13.0432 13.5523 12.5955 14 12.0432 14C11.4912 13.9998 11.0433 13.5521 11.0432 13V6C11.0432 5.44785 11.4911 5.00022 12.0432 5Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3108 1C11.0806 -0.333293 13.0058 -0.333211 13.7757 1L23.7347 18.25C24.5044 19.5833 23.5418 21.25 22.0022 21.25H2.08426L1.94169 21.2451C0.486299 21.1461 -0.393723 19.5416 0.351842 18.25L10.3108 1ZM2.08426 19.25H22.0022L12.0432 2L2.08426 19.25Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningX2);
export default __webpack_public_path__ + "static/media/WarningX2.5e122dcc4ad097d5ec4d4504ce3ae5b2.svg";
export { ForwardRef as ReactComponent };